/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kindle_Open_A_BookInputs */

const en_kindle_open_a_book = /** @type {(inputs: Kindle_Open_A_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open a book to listen`)
};

const es_kindle_open_a_book = /** @type {(inputs: Kindle_Open_A_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre un libro para escuchar`)
};

/**
* | output |
* | --- |
* | "Open a book to listen" |
*
* @param {Kindle_Open_A_BookInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const kindle_open_a_book = /** @type {((inputs?: Kindle_Open_A_BookInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kindle_Open_A_BookInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_kindle_open_a_book(inputs)
	return en_kindle_open_a_book(inputs)
});